import { ParamKeyValuePair } from 'react-router-dom';
import { DataFilterDateRangeValue } from '@asset-metrix/portal-gateway-client-js';

import { Filter } from '../store/states/filterTypes';

// returns filter selections as ParamKeyValuePair[] to be used with urlSearchParams
// removes null values / undefined selections
export function filtersToKeyValuePairs(filters: Filter): ParamKeyValuePair[] {
  const keyValuePairs: ParamKeyValuePair[] = [];
  for (const [key, filter] of Object.entries(filters)) {
    if (filter == null) {
      continue;
    } else if (filter.display === 'multi-select') {
      const values = filter.selection ?? [];
      for (const value of values) {
        keyValuePairs.push([key, String(value)]);
      }
    } else if (
      ['single-select', 'search', 'single-date-picker'].includes(filter.display)
    ) {
      const value: string | undefined = filter.selection?.toString();
      if (value != null) {
        keyValuePairs.push([key, value]);
      }
    } else if (
      ['range-date-picker', 'range-number-picker'].includes(filter.display)
    ) {
      const value = filter.selection as DataFilterDateRangeValue;
      if (value != null) {
        const formattedValue = JSON.stringify({
          ...(value.start != null ? { gte: value.start } : {}),
          ...(value.end != null ? { lte: value.end } : {}),
        });
        keyValuePairs.push([key, formattedValue]);
      }
    }
  }
  return keyValuePairs;
}
